// extracted by mini-css-extract-plugin
export default {"heading":"ManageDevices_heading__7BVyG","wrapper":"ManageDevices_wrapper__Hm1wW"};